import React from "react";
import { Form, Checkbox, Select, Row, Col } from "antd";
import "../BusinessSignupForm.css";

const renderCheckboxGrid = (items, value, onChange) => (
  <Checkbox.Group value={value || []} onChange={onChange} style={{ width: "100%" }}>
    <Row gutter={[0, 8]}>
      {items.map((item) => (
        <Col span={12} key={item}>
          <Checkbox value={item}>{item}</Checkbox>
        </Col>
      ))}
    </Row>
  </Checkbox.Group>
);

const Section3 = ({ formValues, setFormValues }) => (
  <Form layout="vertical">
    {/*Q10 – Campaign Objectives */}
    <Form.Item label="10. What do you want your marketing campaign to achieve?">
      <h4>Awareness & Branding</h4>
      {renderCheckboxGrid(
        [
          "Build or strengthen brand identity",
          "Improve market positioning",
          "Differentiate from competitors",
          "Increase brand awareness", 
          "Introduce a new product or service", 

        ],
        formValues.objectivesAwareness,
        (checked) =>
          setFormValues({ ...formValues, objectivesAwareness: checked })
      )}

      <h4 style={{ marginTop: "16px" }}>Engagement & Interest</h4>
      {renderCheckboxGrid(
        [
          "Create desire for your offering",
          "Grow your social media or online following",
          "Educate your audience about your offerings",
          "Support community engagement or local outreach",
        ],
        formValues.objectivesEngagement,
        (checked) =>
          setFormValues({ ...formValues, objectivesEngagement: checked })
      )}

      <h4 style={{ marginTop: "16px" }}>Action & Results</h4>
      {renderCheckboxGrid(
        [
          "Drive traffic (online or in-person)",
          "Generate leads or form completions",
          "Encourage a specific call to action (e.g., signups, bookings)",
          "Promote a time-sensitive offer or event",
        ],
        formValues.objectivesAction,
        (checked) =>
          setFormValues({ ...formValues, objectivesAction: checked })
      )}
    </Form.Item>

    {/* Q11 – Success Metrics */}
    <Form.Item label="11. How do you want to measure the success of your campaign? (Select up to two)">
      {renderCheckboxGrid(
        [
          "Greater brand awareness",
          "More people signing up for services or products",
          "Higher engagement from target audience",
          "More people visiting my website or store",
          "Increased sales or revenue",
          "More social media interactions (likes, shares, comments)",
          "More inquiries or questions from prospects",         
        ],
        formValues.successMetrics,
        (checked) =>
          setFormValues({ ...formValues, successMetrics: checked })
      )}
    </Form.Item>

    {/* Q12 – Advertising Start Time */}
    <Form.Item label="12. When would you like to begin advertising or promoting your business?">
      <Select
        placeholder="Select timeline"
        value={formValues.startTime}
        onChange={(val) => setFormValues({ ...formValues, startTime: val })}
      >
        <Select.Option value="ASAP">As soon as possible</Select.Option>
        <Select.Option value="NextMonth">Within the next month</Select.Option>
        <Select.Option value="1-3Months">In 1-3 months</Select.Option>
        <Select.Option value="MoreThan3">In more than 3 months</Select.Option>
        <Select.Option value="NotSure">I'm not sure yet</Select.Option>
      </Select>
    </Form.Item>
  </Form>
);

export default Section3;
